import { render } from "./UnlockFourDiceModal.vue?vue&type=template&id=af25922a&scoped=true"
import script from "./UnlockFourDiceModal.vue?vue&type=script&lang=js"
export * from "./UnlockFourDiceModal.vue?vue&type=script&lang=js"

import "./UnlockFourDiceModal.vue?vue&type=style&index=0&id=af25922a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af25922a"]])

export default __exports__